import { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

/**
 * Expands positions to doc level
 */
export const expandPositionsToDocDepth = ({
	doc,
	startPos,
	endPos,
}: {
	doc: PMNode;
	startPos: number;
	endPos: number;
}): [number, number] => {
	const $startPos = doc.resolve(startPos);
	const $endPos = doc.resolve(endPos);
	const start = $startPos.depth === 0 ? startPos : Math.max($startPos.start(1) - 1, 0);
	const end = $endPos.depth === 0 ? endPos : Math.min($endPos.end(1) + 1, doc.content.size);
	return [start, end];
};
